import _ from 'lodash';

import { default as AddNoteItem } from 'actions/composition/add_note';
import getCompositionsStore from 'actions/customer/lib/get_compositions_store';

export default class AddNote {
  constructor(context) {
    this.context = context;
  }

  run({ compositionId, content }) {
    const composition = getCompositionsStore(this.context).findBy({ id: compositionId });
    if (!composition) {
      return;
    }

    const compositionContent = composition.toJs().content;
    _.forEach(content, (html, attr) => {
      compositionContent[attr] = html;
    });

    this.context.executeAction(AddNoteItem, {
      compositionId,
      content: compositionContent,
    });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/composer/add_note.js